"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[824],{

/***/ 44824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96245);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46679);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks_useLockedBody__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54473);
/* harmony import */ var _utils_storage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44920);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27643);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21190);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18716);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25934);
/* harmony import */ var _utils_auth__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62619);













var Navbar = function(props) {
    var ref, ref1, ref2, ref3;
    var accessToken = (0,src_store__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(state) {
        return state.accessToken;
    });
    var accessTokenDecoded = !!accessToken ? (0,jwt_decode__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(accessToken) : null;
    //   const [vendorsProfileResult] = useQuery<GetMyVendorProfileQuery>({
    //     query: GetMyVendorProfile,
    //     pause: !accessToken,
    //   });
    if (((ref = props.vendorsProfileResult) === null || ref === void 0 ? void 0 : (ref1 = ref.error) === null || ref1 === void 0 ? void 0 : ref1.message.includes("unauthenticated")) && !!(accessTokenDecoded === null || accessTokenDecoded === void 0 ? void 0 : accessTokenDecoded.exp) && Date.now() >= (accessTokenDecoded === null || accessTokenDecoded === void 0 ? void 0 : accessTokenDecoded.exp) * 1000) {
        (0,_utils_auth__WEBPACK_IMPORTED_MODULE_9__/* .refreshOnClientError */ .WD)();
    }
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), show = ref4[0], setShow = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(!accessToken), 2), search = ref5[0], setSearch = ref5[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        setShow(true);
        if (!accessToken) {
            setSearch(true);
        }
    }, [
        accessToken
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var onPropsPage = router.pathname.includes("interest");
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), showDrawer = ref6[0], setShowDrawer = ref6[1];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_hooks_useLockedBody__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), 2), setLocked = ref7[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .AnimatePresence */ .M, {
                exitBeforeEnter: true,
                children: showDrawer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_12__/* .motion.div */ .E.div, {
                    initial: {
                        x: 100,
                        opacity: 0
                    },
                    animate: {
                        x: 0,
                        opacity: 1
                    },
                    exit: {
                        x: -100,
                        opacity: 0
                    },
                    className: "top-0 left-0 h-screen z-20 fixed w-screen bg-inawo-green py-9 pr-9 pl-14 ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full max-w-[1300px] flex flex-col justify-start items-start gap-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-8 h-8 grid scale-150 transform place-items-center place-self-end justify-self-end self-end cursor-pointer mb-4",
                                onClick: function() {
                                    setLocked(false);
                                    setShowDrawer(false);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    iconName: "close"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "font-sfpro text-white font-medium text-5xl md:text-7xl flex flex-col justify-start items-start gap-12",
                                children: !!accessToken && show ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        ((ref2 = props.vendorsProfileResult) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.getMyVendorProfile.id) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/dashboard",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                className: "transition hover:text-inawo-gold",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "text-inawo-gold text-base",
                                                        children: "01"
                                                    }),
                                                    "Dashboard"
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/become-a-vendor",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                className: "transition hover:text-inawo-gold",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "text-inawo-gold text-base",
                                                        children: "01"
                                                    }),
                                                    "Become a Vendor"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "cursor-pointer transition hover:text-inawo-gold",
                                            onClick: function() {
                                                router.push("/login");
                                                //setLocked(false);
                                                (0,_utils_storage__WEBPACK_IMPORTED_MODULE_7__/* .deleteAccessCookie */ .i)();
                                                (0,_utils_storage__WEBPACK_IMPORTED_MODULE_7__/* .deleteRefreshCookie */ .V6)();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-inawo-gold text-base",
                                                    children: "02"
                                                }),
                                                "Log out"
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/login",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                className: "transition hover:text-inawo-gold",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "text-inawo-gold text-base",
                                                        children: "01"
                                                    }),
                                                    "Sign In"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/register",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                className: "transition hover:text-inawo-gold",
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "text-inawo-gold text-base",
                                                        children: "02"
                                                    }),
                                                    "Sign Up"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/register?next=become-a-vendor",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                className: "transition hover:text-inawo-gold",
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "text-inawo-gold text-base",
                                                        children: "03"
                                                    }),
                                                    "Become a Vendor"
                                                ]
                                            })
                                        }),
                                        " "
                                    ]
                                })
                            })
                        ]
                    })
                }, (0,uuid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)()) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex justify-between items-center w-full py-4 pt-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-start gap-1 items-end font-sfpro font-semibold text-xs text-inawo-grey",
                        children: onPropsPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-start items-end",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    iconName: "pinGreen"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "font-sfpro font-semibold text-xl md:text-2xl",
                                    children: "Interests"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "cursor-pointer",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            iconName: "logoGreen"
                                        })
                                    })
                                }),
                                "Vendors"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-center items-center gap-1",
                        children: [
                            search && show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: "/search",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "cursor-pointer p-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        iconName: "search"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "cursor-pointer p-2",
                                onClick: function() {
                                    setLocked(true);
                                    setShowDrawer(true);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    iconName: "burger"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Navbar);


/***/ }),

/***/ 54473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useLockedBody; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useIsomorphicLayoutEffect.tsx

var useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;
/* harmony default export */ var hooks_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);

;// CONCATENATED MODULE: ./src/hooks/useLockedBody.tsx

// See: https://usehooks-ts.com/react-hook/use-isomorphic-layout-effect

function useLockedBody() {
    var initialLocked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref = (0,react.useState)(initialLocked), locked = ref[0], setLocked = ref[1];
    // Do the side effect before render
    hooks_useIsomorphicLayoutEffect(function() {
        if (!locked) {
            return;
        }
        // Save initial body style
        var originalOverflow = document.body.style.overflow;
        var originalPaddingRight = document.body.style.paddingRight;
        // Lock body scroll
        document.body.style.overflow = "hidden";
        // Get the scrollBar width
        var root = document.getElementById("___gatsby"); // or root
        var scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        // Avoid width reflow
        if (scrollBarWidth) {
            document.body.style.paddingRight = "".concat(scrollBarWidth, "px");
        }
        return function() {
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) {
                document.body.style.paddingRight = originalPaddingRight;
            }
        };
    }, [
        locked
    ]);
    // Update state if initialValue changes
    (0,react.useEffect)(function() {
        if (locked !== initialLocked) {
            setLocked(initialLocked);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialLocked
    ]);
    return [
        locked,
        setLocked
    ];
}
/* harmony default export */ var hooks_useLockedBody = (useLockedBody);


/***/ }),

/***/ 27643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js + 1 modules
var esm = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/utils/storage.ts
var storage = __webpack_require__(44920);
;// CONCATENATED MODULE: ./src/store/auth/index.ts

var refreshCookie = (0,storage/* getRefreshCookie */.Qy)();
var accessCookie = (0,storage/* getAccessCookie */.tN)();
var createAuthSlice = function(set) {
    return {
        accessToken: accessCookie ? accessCookie : "",
        setAccessToken: function(arg, ctx) {
            set(function() {
                return {
                    accessToken: arg
                };
            });
            if (ctx) {
                (0,storage/* setAccessCookie */.AA)(arg, ctx);
            } else {
                (0,storage/* setAccessCookie */.AA)(arg);
            }
        },
        refreshToken: refreshCookie ? refreshCookie : "",
        setRefreshToken: function(arg, ctx) {
            set(function() {
                return {
                    refreshToken: arg
                };
            });
            if (ctx) {
                (0,storage/* setRefreshCookie */.gE)(arg, ctx);
            } else {
                (0,storage/* setRefreshCookie */.gE)(arg);
            }
        }
    };
};
/* harmony default export */ var auth = (createAuthSlice);

;// CONCATENATED MODULE: ./src/store/index.ts



// import { immer } from "zustand/middleware/immer";

var useStore = (0,esm/* default */.ZP)()(function() {
    for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++){
        a[_key] = arguments[_key];
    }
    return (0,_object_spread/* default */.Z)({}, auth.apply(void 0, (0,_to_consumable_array/* default */.Z)(a)));
});
// const useStore = create<StoreType>()(
//   immer((...a) => ({
//     ...createAuthSlice(...a),
//   }))
// );
/* harmony default export */ var store = (useStore);


/***/ }),

/***/ 62619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WD": function() { return /* binding */ refreshOnClientError; }
/* harmony export */ });
/* unused harmony exports getAuthClient, addAuthToOperationClient, willAuthErrorClient, didAuthErrorClient, onErrorClient */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94301);
/* harmony import */ var isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44920);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86501);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96245);









var refreshOnClientError = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var errorOut, ref, resultInitial, result, _args = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    errorOut = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false;
                    ;
                    _ctx.next = 4;
                    return isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1___default()("https://staging.inawo.live/query", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            query: "\n							query Refresh($refresh_token: String!) {\n								refresh(refresh_token: $refresh_token) {\n									refresh_token\n									access_token\n									access_expiry\n								}\n							}\n					",
                            variables: {
                                refresh_token: (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .getRefreshCookie */ .Qy)() ? (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .getRefreshCookie */ .Qy)() : ""
                            }
                        })
                    });
                case 4:
                    resultInitial = _ctx.sent;
                    _ctx.next = 7;
                    return resultInitial.json();
                case 7:
                    result = _ctx.sent;
                    if ((ref = result.data) === null || ref === void 0 ? void 0 : ref.refresh) {
                        // save the new tokens in storage for next restart
                        (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .setRefreshCookie */ .gE)(result.data.refresh.refresh_token);
                        (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .setAccessCookie */ .AA)(result.data.refresh.access_token);
                        react_hot_toast__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .ZP.error("Please refresh your browser window.");
                    } else {
                        (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .deleteAccessCookie */ .i)();
                        (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .deleteRefreshCookie */ .V6)();
                        errorOut && react_hot_toast__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .ZP.error("Your session has expired. Please login afresh.");
                    }
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function refreshOnClientError() {
        return _ref.apply(this, arguments);
    };
}();
// still a work in progress, need to find a way to pass in req and res from context
var getAuthClient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var authState, ref, accessToken, refreshToken, resultInitial, result;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    authState = param.authState;
                    ;
                    if (authState) {
                        _ctx.next = 8;
                        break;
                    }
                    accessToken = (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .getAccessCookie */ .tN)();
                    refreshToken = (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .getRefreshCookie */ .Qy)();
                    if (!accessToken) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        accessToken: accessToken,
                        refreshToken: refreshToken
                    });
                case 7:
                    return _ctx.abrupt("return", null);
                case 8:
                    _ctx.next = 10;
                    return isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1___default()("https://staging.inawo.live/query", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            query: "\n										query Refresh($refresh_token: String!) {\n								refresh(refresh_token: $refresh_token) {\n									refresh_token\n									access_token\n									access_expiry\n								}\n							}\n					",
                            variables: {
                                refresh_token: authState.refreshToken
                            }
                        })
                    });
                case 10:
                    resultInitial = _ctx.sent;
                    _ctx.next = 13;
                    return resultInitial.json();
                case 13:
                    result = _ctx.sent;
                    if (!((ref = result.data) === null || ref === void 0 ? void 0 : ref.refresh)) {
                        _ctx.next = 20;
                        break;
                    }
                    // save the new tokens in storage for next restart
                    (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .setRefreshCookie */ .gE)(result.data.refresh.refresh_token);
                    (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .setAccessCookie */ .AA)(result.data.refresh.access_token);
                    return _ctx.abrupt("return", {
                        accessToken: result.data.refresh.access_token,
                        refreshToken: result.data.refresh.refresh_token
                    });
                case 20:
                    // otherwise, if refresh fails, log clear storage and log out
                    console.log("Vendors Should be Client RefreshQuery Home page Error :>> ", result);
                    (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .deleteAccessCookie */ .i)();
                    (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .deleteRefreshCookie */ .V6)();
                    // your app logout logic should trigger here
                    react_hot_toast__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .ZP.error("Please refresh your browser window.");
                    return _ctx.abrupt("return", null);
                case 25:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getAuthClient(_) {
        return _ref.apply(this, arguments);
    };
}();
var addAuthToOperationClient = function(param) {
    var authState = param.authState, operation = param.operation;
    // the token isn't in the auth state, return the operation without changes
    if (!authState || !authState.accessToken) {
        return operation;
    }
    // fetchOptions can be a function (See Client API) but you can simplify this based on usage
    var fetchOptions = typeof operation.context.fetchOptions === "function" ? operation.context.fetchOptions() : operation.context.fetchOptions || {};
    return makeOperation(operation.kind, operation, _object_spread_props(_object_spread({}, operation.context), {
        requestPolicy: "network-only",
        fetchOptions: _object_spread_props(_object_spread({}, fetchOptions), {
            headers: _object_spread_props(_object_spread({}, fetchOptions.headers), {
                "x-user-token": authState.accessToken ? "".concat(authState.accessToken) : ""
            })
        })
    }));
};
var willAuthErrorClient = function(param) {
    var authState = param.authState;
    //if there's no authState the trigger the auth arror
    if (!authState) return true;
    // e.g. check for expiration, existence of auth etc
    var accessTokenDecoded = jwt_decode(authState.accessToken);
    var refreshTokenDecoded = jwt_decode(authState.refreshToken);
    // if access token will almost expire
    if (!!(accessTokenDecoded === null || accessTokenDecoded === void 0 ? void 0 : accessTokenDecoded.exp) && Date.now() >= (accessTokenDecoded === null || accessTokenDecoded === void 0 ? void 0 : accessTokenDecoded.exp) * 1000) {
        return true;
    }
    // if refresh token will almost expire
    if (!!(refreshTokenDecoded === null || refreshTokenDecoded === void 0 ? void 0 : refreshTokenDecoded.exp) && Date.now() >= (refreshTokenDecoded === null || refreshTokenDecoded === void 0 ? void 0 : refreshTokenDecoded.exp) * 1000) {
        return true;
    }
    return false;
};
var didAuthErrorClient = function(param) {
    var error = param.error;
    return error.graphQLErrors.some(function(e) {
        return e.message.includes("unauthenticated");
    });
};
var onErrorClient = function(param, _operation) {
    var graphQLErrors = param.graphQLErrors, networkError = param.networkError;
    if (graphQLErrors) {
        if (graphQLErrors.some(function(param) {
            var message = param.message;
            return message.includes("unauthenticated");
        })) {
            toast.error("Your session has expired.");
        }
    }
    if (networkError) console.log("[Network error]: ".concat(networkError));
};


/***/ })

}]);